import { render, staticRenderFns } from "./iDalgo-Customer-Settings.vue?vue&type=template&id=637fc194"
import script from "./iDalgo-Customer-Settings.vue?vue&type=script&lang=js"
export * from "./iDalgo-Customer-Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports